<template>
  <div class="panel-item first-panel">
    <el-select   popper-class="myClass"  :popper-append-to-body="false"  @change="select_change" class="title_name select_dark_box" v-model="value"
      placeholder="请选择">
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
    </el-select>
    <div ref="chart" class="chart-container"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    chartblock: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      options: [
        { value: 1, label: '订单数据' },
        { value: 2, label: 'GMV数据' }
      ],
      value: 1,
      labels:['4:00', '8:00', '12:00', '16:00', '20:00', '24:00'],
      columndata: [5000, 6000, 22000, 12000, 30000, 15000],
      breakdata: [18000, 10000, 28000, 20000, 14000, 16000],
      chartInstance: null
    }
  },
  watch: {
    chartblock: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.select_change()
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.initChart()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.chartInstance) {
      this.chartInstance.dispose()
      this.chartInstance = null
    }
  },
  methods: {
    initChart() {
      this.chartInstance = echarts.init(this.$refs.chart)
      this.updateChart()
    },
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize()
      }
    },
    select_change() {
      this.labels = this.chartblock.labels || []
      if (this.value === 1) {
        this.columndata = this.chartblock.order_data || []
        this.breakdata = this.chartblock.order_settle_data || []
      } else if (this.value === 2) {
        this.columndata = this.chartblock.gmv_data || []
        this.breakdata = this.chartblock.gmv_settle_data || []
      }
      this.updateChart()
    },
    updateChart() {
      if (!this.chartInstance) return

      const option = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['付款数据', '结算数据'],
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '7%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          name: '(时间)',
          nameLocation: 'middle',  // 将名称放置在中间
          nameGap: 20,            // 调整名称与轴线的距离
          nameTextStyle: {
            padding: [4, 0, 0, 230]  // 上、右、下、左的padding，左padding为正数使文字右移
          },
          data: this.labels,
          axisLine: { lineStyle: { color: '#ccc' } },
          axisLabel: { color: '#fff' }
        },
        yAxis: {
          type: 'value',
          name: '(元)',
          nameTextStyle: {
            padding: [0, 34, 0, 0]  // 上、右、下、左的padding，左padding为正数使文字右移
          },
          axisLine: { lineStyle: { color: '#ccc' } },
          axisLabel: { color: '#fff' },
          splitLine: { lineStyle: { color: '#444' } }
        },
        series: [
          {
            name: '付款数据',
            type: 'bar',  // Changed to bar chart
            data: this.breakdata,
            itemStyle: {
              color: '#4fc3f7'
            },
            barWidth: '40%'
          },
          {
            name: '结算数据',
            type: 'line',  // Changed to line chart
            data: this.columndata,
            smooth: true,
            symbol: 'none',
            itemStyle: {
              color: '#ffd54f'
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(255, 221, 85, 0.3)' },
                { offset: 1, color: 'rgba(255, 221, 85, 0)' }
              ])
            },
            emphasis: {
              lineStyle: {
                shadowBlur: 15,
                shadowColor: 'rgba(255, 221, 85, 0.8)'
              }
            },
          }
          // {
          //   name: '付款数据',
          //   type: 'line',  // Changed to line chart
          //   data: this.columndata,
          //   smooth: true,
          //   symbol: 'none',
          //   itemStyle: {
          //     color: '#ffd54f'
          //   },
          //   areaStyle: {
          //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          //       { offset: 0, color: 'rgba(255, 221, 85, 0.3)' },
          //       { offset: 1, color: 'rgba(255, 221, 85, 0)' }
          //     ])
          //   },
          //   emphasis: {
          //     lineStyle: {
          //       shadowBlur: 15,
          //       shadowColor: 'rgba(255, 221, 85, 0.8)'
          //     }
          //   },
          // },
          // {
          //   name: '结算数据',
          //   type: 'bar',  // Changed to bar chart
          //   data: this.breakdata,
          //   itemStyle: {
          //     color: '#4fc3f7'
          //   },
          //   barWidth: '40%'
          // }
        ]
      }

      this.chartInstance.setOption(option)
    }
  }
}
</script>

<style lang="scss" scoped>
.panel-item {
  width: 490px;
  height: 420px;
  background: url(../../../assets/_s-image_sector_bg.png) no-repeat;
  background-size: 100% 100%;

  &.first-panel {
    margin: 30px 0 35px 0;
  }
}

.title_name {
  padding: 23px 0 23px 83px;
  font-weight: 400;
  font-size: 22px;
  color: #FFFFFF;
}

.chart-container {
  width: calc(100% - 30px);
  height: 300px;
  padding: 0 20px;
}

::v-deep .el-input {
  background: none !important;
}

::v-deep .el-input__inner {
  width: 150px;
  background: none !important;
  border: none !important;
  font-size: 22px;
  color: #FFFFFF;
}

::v-deep .el-select__caret .el-icon-arrow-up {
  color: #fff !important;
}

::v-deep .el-input__icon {
  color: #fff !important;
  font-size: 22px !important;
  font-weight: 700 !important;
}


::v-deep .el-select-dropdown.myClass {
  background-color:#2c629f !important;
  border: 1px solid #050b27;
  color: #aacfe2 !important;
}
::v-deep .el-select-dropdown__item{
   background-color:#2c629f !important;
  // border: 1px solid #050b27;
  color: #aacfe2 !important;
}
::v-deep .selected{
  color: #53b7f9 !important;
}
::v-deep .hover{
 background-color: #153059 !important;
}

</style> 